import { getLogoPath, isThemeBackgroundAsset } from "common/assetUtils";
import { ds } from "js/core/models/dataService";
import Logos from "js/core/models/logos";
import getLogger from "js/core/logger";

const logger = getLogger();

export async function getThemeBackgroundImageUrl(backgroundImage, { size = "original", reloadCache = false } = {}) {
    if (!backgroundImage?.asset) {
        return null;
    }

    try {
        if (isThemeBackgroundAsset(backgroundImage)) {
            const asset = await ds.assets.getAssetById(backgroundImage.asset, backgroundImage.content_type);
            return asset.getURL(size, reloadCache);
        }

        return Logos.getSignedUrlAndLoad(getLogoPath(backgroundImage.asset), reloadCache);
    } catch (err) {
        logger.error(err, "getThemeBackgroundImageUrl() failed", {
            asset: backgroundImage.asset,
            content_type: backgroundImage.content_type,
            size
        });
        // Thumbs can go blank; canvas/export must not silently succeed.
        if (size === "original") {
            throw err;
        }
        return null;
    }
}
